/**
 * Accordion Component (Reusable)
 * Uses data attributes for initialization
 *
 * HTML Structure:
 * <div data-accordion>
 *   <div class="accordion__item" data-accordion-item>
 *     <button class="accordion__trigger" data-accordion-trigger aria-expanded="false">
 *       <span class="accordion__trigger-text">Question</span>
 *       <span class="accordion__icon">{icon}</span>
 *     </button>
 *     <div class="accordion__panel" data-accordion-panel>
 *       <div class="accordion__content">
 *         <div class="accordion__content-box">Answer</div>
 *       </div>
 *     </div>
 *   </div>
 * </div>
 */

(function() {
  'use strict';

  class Accordion {
    constructor(container) {
      this.container = container;
      this.items = container.querySelectorAll('[data-accordion-item]');
      this.allowMultiple = container.dataset.accordionMultiple === 'true';

      this.init();
    }

    init() {
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-accordion-trigger]');
        if (trigger) {
          trigger.addEventListener('click', () => this.toggle(item));
        }

        // Initialize state from aria-expanded
        if (trigger && trigger.getAttribute('aria-expanded') === 'true') {
          item.classList.add('is-active');
        }
      });
    }

    toggle(item) {
      const isActive = item.classList.contains('is-active');
      const trigger = item.querySelector('[data-accordion-trigger]');

      // Close others if not allowing multiple
      if (!this.allowMultiple && !isActive) {
        this.closeAll();
      }

      // Toggle this item
      item.classList.toggle('is-active', !isActive);

      if (trigger) {
        trigger.setAttribute('aria-expanded', !isActive);
      }
    }

    closeAll() {
      this.items.forEach((item) => {
        item.classList.remove('is-active');
        const trigger = item.querySelector('[data-accordion-trigger]');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    open(item) {
      item.classList.add('is-active');
      const trigger = item.querySelector('[data-accordion-trigger]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }
    }

    close(item) {
      item.classList.remove('is-active');
      const trigger = item.querySelector('[data-accordion-trigger]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    }
  }

  // Auto-initialize all accordions
  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach((container) => {
      if (!container._accordionInstance) {
        container._accordionInstance = new Accordion(container);
      }
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }

  // Theme Editor support
  document.addEventListener('shopify:section:load', initAccordions);

  // Block select for Theme Editor
  document.addEventListener('shopify:block:select', (event) => {
    const accordionItem = event.target.closest('[data-accordion-item]');
    if (accordionItem) {
      const accordion = accordionItem.closest('[data-accordion]');
      if (accordion && accordion._accordionInstance) {
        accordion._accordionInstance.open(accordionItem);
      }
    }
  });

  // Expose for external use
  window.Accordion = Accordion;
})();
